<template>
  <div>
    <el-upload
      :disabled="disabled"
      class="avatar-uploader"
      :action="uploadAction"
      :show-file-list="false"
      :on-success="handleAvatarScucess"
      :before-upload="beforeAvatarUpload"
      :style="widths"
    >
      <img v-if="value" :src="longUrl" class="avatar"  style="width: 100%">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <div v-if="value" class="avatar-left" style="width:30px;line-height:70px;">
      <a href="javascript:" @click="deletePic"><i class="el-icon-delete avatar-view" ></i></a>
      <a href="javascript:" @click="enlargePic"><i class="el-icon-view avatar-view"></i></a>
    </div>
    <el-dialog z-index="4000" :visible.sync="dialogVisible" v-model="dialogVisible" size="auto" :modal="false">
      <img width="100%" :src="longUrl" alt="">
        <div class="close-pic">
       <el-button type="primary" @click.native="dialogVisible = false">关 闭</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
  import util from '../common/util'
  export default {
    props: {
      value:String,
      disabled:{
        type:Boolean,
        default:false
      },
      widths:String,
      watermark:String
    },
    data(){
      return {
        uploadAction:global.serverHost+"server/system/upload.aspx?watermark="+this.watermark,
        dialogVisible:false
      }
    },
    computed: {
      longUrl: function () {
        return global.serverHost+ '/upload/'+this.value
      }
    },
    methods:{
      deletePic:function () {
        this.$emit("input","")
      },
      enlargePic:function () {
        this.dialogVisible = true;
      },
      handleAvatarScucess(res, file) {
        if(res && !res.success){
          util.msg("上传出错")
        }else{
          this.$emit('input', res.filename)
        }
        //this.FLicensePic = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      }
    }
  }
</script>


<style scoped>
  .avatar-uploader {
    width: 178px;
    height: 178px;
    border: 1px dashed #c0ccda;
    background-color: #fbfdff;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    float: left
  }

  .avatar-uploader:hover {
    border-color: #20a0ff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
  }

  .avatar-view {
    font-size: 2.5em;
    color:#20a0ff;
  }

  .avatar-left{
    float: left;
    height: 178px;
    line-height:178px;
  }

  .close-pic{
    text-align: center;margin-top: 20px
  }
</style>



// WEBPACK FOOTER //
// src/components/PicUpload.vue